import { Grid, Skeleton, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Link as RouterLink } from "react-router-dom";

export default function OurPolicies({data}){

    return(
        <Container maxWidth='lg'
            sx={{
                m:'3rem auto',
                textAlign:'center'
            }}
        >
            <Typography variant='h4'
                sx={{
                    fontSize:'1.4rem',
                    fontWeight:800,
                    color:'#265DA5'
                }}
            >
                {data? data.heading : <Skeleton/>}
            </Typography>
            <Typography variant='p' component='p'
                sx={{
                    m:'1rem 0 2rem 0'
                }}
            >
                {data? data.subheading : <Skeleton/>}
            </Typography>
            <Grid container spacing={4}>
                {data?
                    data.policies.map((policy)=>{
                        //console.log(policy)
                        return(
                            <Grid item xs={12} md={6}>
                                <Box
                                    sx={{
                                        display:'flex',
                                        alignItems:'center',
                                    }}
                                >
                                    <InsertDriveFileOutlinedIcon
                                        fontSize="large"
                                        sx={{
                                            color:'#0C5EAA',
                                            mr:'1rem'
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            textAlign:'left'
                                        }}
                                    >
                                        <Typography
                                             component={RouterLink}
                                             to={policy.link}
                                            target='_blank'
                                            sx={{
                                                fontSize:'1.1rem',
                                                fontWeight:600,
                                                color:'#E9530D',
                                                textDecoration:'none'
                                            }}
                                        >
                                            {policy.title}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        );
                    })
                :
                    Array(6).fill(0).map(()=>{
                        return(
                            <Grid item xs={12} md={6}>
                                <Skeleton/>
                            </Grid>
                        );
                    })
                }
            </Grid>
        </Container>
    );
}